import { Modal } from 'antd'
import { useTranslation } from 'react-i18next';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import classes from './RoomNameExistsModal.module.scss';
import { getTheme } from 'helpers/getTheme';

type RoomNameExistsModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  name: string;
};

const RoomNameExistsModal = ({ isOpen, onCancel, name }: RoomNameExistsModalProps) => {
	const { t } = useTranslation();
  return (
    <Modal
      title={t('Rooms.modals.roomNameExists.title')}
      open={isOpen}
      width={540}
      onOk={onCancel}
      centered
      closable={false}
      className={getTheme()}
      cancelButtonProps={{style: {display: 'none'}}}
    >
      <div className={classes.modalWrap}>
        <ExclamationCircleOutlined className={classes.icon} />
        <div className={classes.text}>
          <p>{t('Rooms.modals.roomNameExists.description', { name })}</p>
          <p className={classes.hint}>{t('Rooms.modals.roomNameExists.hint')}</p>
        </div>
      </div>
    </Modal>
  )
};

export default RoomNameExistsModal
